'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = require('react-addons-shallow-compare');

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _Constants = require('./Constants');

var _AvatarResolver = require('./AvatarResolver');

var _Image = require('./lib/Image');

var _LookupRecord = require('./Records/LookupRecord');

var _LookupRecord2 = _interopRequireDefault(_LookupRecord);

var _defaultFetchAvatars = require('./api/defaultFetchAvatars');

var _defaultFetchAvatars2 = _interopRequireDefault(_defaultFetchAvatars);

var _defaultPortalId = require('./lib/defaultPortalId');

var _defaultPortalId2 = _interopRequireDefault(_defaultPortalId);

var _compat = require('./lib/compat');

var _UIAvatarDisplay = require('./UIAvatarDisplay/UIAvatarDisplay');

var _UIAvatarDisplay2 = _interopRequireDefault(_UIAvatarDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_no_avatar = [/hubfs\/defaults\/contact\.png/, /hubfs\/defaults\/company\.png/, /avatar\/hash\/4bd0df0db6227e87de4031baa4422b73/, /avatar\/hash\/cc7a027acb4f854bd9b1d3a511d1740c/, /avatar\/hash\/5be48140e95ae69927946a77d6c29d1a/, /avatars\.s3\.amazonaws\/default-100/, /hubspot-avatars\.s3\.amazonaws\.com\/default-100/];

var resolver = (0, _AvatarResolver.getAvatarResolver)();
var DEFAULT_LOOKUP_RECORD = new _LookupRecord2.default();

exports.default = _react2.default.createClass({
  displayName: 'UIAvatarRequest',
  getDefaultProps: function getDefaultProps() {
    return {
      size: 'sm',
      portalId: (0, _defaultPortalId2.default)(),
      fetchAvatars: _defaultFetchAvatars2.default,
      isAuthed: true
    };
  },
  getInitialState: function getInitialState() {
    return {
      lookupRecord: DEFAULT_LOOKUP_RECORD,
      avatarURI: undefined,
      error: undefined,
      loaded: false
    };
  },
  componentWillMount: function componentWillMount() {
    this.updateAvatarUrl(this.props);
  },
  componentDidMount: function componentDidMount() {
    this._isMounted = true;
    this.startWatching();
    this.updateAvatarUrl(this.props);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
  },
  componentDidUpdate: function componentDidUpdate() {
    this.updateAvatarUrl(this.props);
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
    this.stopWatching();
  },
  handleResolverUpdate: function handleResolverUpdate() {
    this.updateAvatarUrl(this.props);
  },
  startWatching: function startWatching() {
    resolver.watch(this.handleResolverUpdate);
  },
  stopWatching: function stopWatching() {
    resolver.unwatch(this.handleResolverUpdate);
  },
  updateAvatarUrl: function updateAvatarUrl(props) {
    var _this = this;

    var size = (0, _compat.computeSizeProp)(props.size);
    var lookupValues = _extends({}, this.makeLookupValues());

    if (!lookupValues.primaryIdentifier || lookupValues.primaryIdentifier.length < 1 || 'deal' === lookupValues.type.toLowerCase() || 'ticket' === lookupValues.type.toLowerCase()) {
      this.setState({
        loaded: true
      });
      return undefined;
    }

    var lookupRecordFromProps = new _LookupRecord2.default(_extends({}, lookupValues, {
      existsInPortal: props.existsInPortal,
      portalId: props.portalId,
      dimensions: _Constants.AVATAR_SIZES[size] !== _Constants.AVATAR_SIZES.responsive ? _Constants.AVATAR_SIZES[size] : _Constants.AVATAR_SIZES.xl
    }));

    var lookupRecord = this.state.lookupRecord.equals(lookupRecordFromProps) ? this.state.lookupRecord : lookupRecordFromProps;

    var avatarURI = resolver.getAvatarURI(lookupRecord, props.fetchAvatars, props.portalId);
    var fetched = (0, _Image.isFetched)(avatarURI);
    var isDefault = typeof avatarURI !== 'string';
    var loaded = isDefault || fetched;

    if (this.state.avatarURI === avatarURI) {
      return null;
    }

    this.setState({
      avatarURI: avatarURI,
      lookupRecord: lookupRecord,
      error: undefined,
      loaded: loaded
    });

    if (loaded) {
      return null;
    }

    // Forces the browser to load the image into the cache to avoid UI-jitters
    // as the image loads in.
    (0, _Image.fetchImage)(avatarURI).then(function () {
      if (_this._isMounted && _this.state.avatarURI === avatarURI) {
        _this.setState({ loaded: true });
      }
    }).catch(function (error) {
      if (_this._isMounted && _this.state.avatarURI === avatarURI) {
        _this.setState({ error: error });
      }
    }).done();

    return null;
  },
  getSrc: function getSrc() {
    var _state = this.state,
        avatarURI = _state.avatarURI,
        error = _state.error,
        loaded = _state.loaded;
    var src = this.props.src;


    if (src) {
      return src;
    }

    if (avatarURI) {
      if (avatarURI && loaded && !error && default_no_avatar.filter(function (regex) {
        return regex.test(avatarURI);
      }).length > 0) {
        return undefined;
      } else if (avatarURI && loaded && !error) {
        return avatarURI;
      }
    }
    return undefined;
  },
  makeLookupValues: function makeLookupValues() {
    var _props = this.props,
        _isHasMore = _props._isHasMore,
        companyId = _props.companyId,
        domain = _props.domain,
        email = _props.email,
        fileManagerKey = _props.fileManagerKey,
        hubSpotUserEmail = _props.hubSpotUserEmail,
        productId = _props.productId,
        type = _props.type,
        vid = _props.vid,
        primaryIdentifier = _props.primaryIdentifier,
        secondaryIdentifier = _props.secondaryIdentifier;

    var selfie = [{ companyId: companyId }, { domain: domain }, { email: email }, { hubSpotUserEmail: hubSpotUserEmail }, { productId: productId }, { vid: vid }].filter(function (value) {
      return value[Object.keys(value)[0]];
    })[0];

    if (_isHasMore) {
      return { type: '_isHasMore' };
    }

    if (primaryIdentifier && secondaryIdentifier && type) {
      return {
        type: type,
        primaryIdentifier: primaryIdentifier,
        secondaryIdentifier: secondaryIdentifier
      };
    }

    if (type && primaryIdentifier) {
      return {
        type: type,
        primaryIdentifier: primaryIdentifier
      };
    }

    // quickest BE response…probably
    if (vid && email && fileManagerKey) {
      return {
        type: 'contact',
        primaryIdentifier: vid,
        secondaryIdentifier: email,
        fileManagerKey: fileManagerKey
      };
    }

    if (vid && email) {
      return {
        type: 'vid',
        primaryIdentifier: vid,
        secondaryIdentifier: email
      };
    }

    // quickest BE response…probably
    if (companyId && domain && fileManagerKey) {
      return {
        type: 'company',
        primaryIdentifier: companyId,
        secondaryIdentifier: domain,
        fileManagerKey: fileManagerKey
      };
    }

    // If we have type
    if (type === 'enrichmentDomain') {
      return (primaryIdentifier || domain) && {
        type: type,
        primaryIdentifier: primaryIdentifier || domain
      };
    }

    if (Object.keys(_Constants.AVATAR_TYPES).filter(function (t) {
      return t === type;
    }).length > 0 && selfie) {
      return {
        type: type,
        primaryIdentifier: Object.keys(selfie).map(function (e) {
          return selfie[e];
        })[0]
      };
    }

    if (selfie) {
      return {
        type: Object.keys(selfie)[0],
        primaryIdentifier: Object.keys(selfie).map(function (e) {
          return selfie[e];
        })[0]
      };
    }

    return {};
  },
  render: function render() {
    var _props2 = this.props,
        _isHasMore = _props2._isHasMore,
        _isHasTooltip = _props2._isHasTooltip,
        _isHoverlayOpen = _props2._isHoverlayOpen,
        _isListReversed = _props2._isListReversed,
        _toolTipOverWrite = _props2._toolTipOverWrite,
        _noDefaultSrc = _props2._noDefaultSrc,
        children = _props2.children,
        className = _props2.className,
        displayName = _props2.displayName,
        href = _props2.href,
        isHoverlay = _props2.isHoverlay,
        onClick = _props2.onClick,
        size = _props2.size,
        socialNetwork = _props2.socialNetwork,
        style = _props2.style,
        textSpacing = _props2.textSpacing,
        truncateLength = _props2.truncateLength,
        type = _props2.type,
        toolTipPlacement = _props2.toolTipPlacement;


    var src = this.getSrc();

    if (_noDefaultSrc && !src) {
      return children ? _react2.default.createElement(
        'div',
        { onClick: onClick },
        children
      ) : _react2.default.createElement('noscript', null);
    }

    return _react2.default.createElement(_UIAvatarDisplay2.default, {
      _isHasMore: _isHasMore,
      _isHasTooltip: _isHasTooltip,
      _isHoverlayOpen: _isHoverlayOpen,
      _isListReversed: _isListReversed,
      _toolTipOverWrite: _toolTipOverWrite,
      children: children,
      className: className,
      displayName: displayName,
      href: href,
      isHoverlay: isHoverlay,
      onClick: onClick,
      size: size,
      socialNetwork: socialNetwork,
      src: src,
      style: style,
      textSpacing: textSpacing,
      truncateLength: truncateLength,
      type: type || this.makeLookupValues().type,
      toolTipPlacement: toolTipPlacement
    });
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.1456/js/UIAvatarRequest.js
// module id = 471
// module chunks = 171